import { BrokerHaulierRating } from '../global/interfaces/BrokerHaulierRating';
import { Tenant } from '../global/interfaces/tenant';

export class HaulierRatingFunctions {
  getHaulierRating(haulier: Tenant, brokerId: string): BrokerHaulierRating {
    const { brokerHauliers } = haulier;
    const res = brokerHauliers.find((bh) => bh.brokerId === brokerId);
    return res?.brokerHaulierRating;
  }
}
